import { render, staticRenderFns } from "./Bookables.vue?vue&type=template&id=30639d3c&"
import script from "./Bookables.vue?vue&type=script&lang=ts&"
export * from "./Bookables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports